// extracted by mini-css-extract-plugin
module.exports = {"image":"OrganicPreviewImage_image__PuGY3"};